import { JSX } from "react";
import { NetworkIntegrityWidgetContainerProperties } from ".";

const NetworkIntegrityWidgetContainer = (props: NetworkIntegrityWidgetContainerProperties): JSX.Element => {
  return (
    <div className="ni-widget-container">
      { props.children }
    </div>
  );
}

export { NetworkIntegrityWidgetContainer };